import { MrbBaseRouteStore } from "mrb/core";

class PremiumSubscriptionRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }

    onBeforeEnter() {
        if (!this.rootStore.premiumSubscriptionStore.hasPortalAccess) {
            return Promise.reject("master.application.premium.subscriptions");
        } else {
            return Promise.reject("master.application.premium.info");
        }
    }
}

export default PremiumSubscriptionRouteStore;
